import React, { FC } from "react";
import { TSeriesListingProps } from "./types/SeriesListing.types";
import LazySection from "../../react-only-components/LazySection";
import ProductCard from "./components/ProductCard";
import { SeriesListingModel } from "./models/SeriesListing.model";
import "../../styles/@shared/product-card-dashboard.scss";

const SeriesListing: FC<TSeriesListingProps> = (props) => {
  const model = new SeriesListingModel(props);

  return (
    <LazySection>
      <div className="product-card-dashboard__wrapper">
        <div className="product-card-dashboard">
          <section className="product-card-dashboard__products">
            {model.items.map((productCard) => (
              <ProductCard
                {...productCard}
                baseUrl={model.baseUrl}
                key={productCard?.id}
                id={productCard?.id}
              />
            ))}
          </section>
        </div>
      </div>
    </LazySection>
  );
};

export default SeriesListing;
